import type { CreateAudienceMutationVariables } from '../../../../graphql/mutation/audiences/CreateAudience.generated';
import { DEFAULT_PROVIDER_ID } from '../../hooks/useProviders';
import { exportType } from '../constants';
import type { AudienceForm } from '../types';
import { getSubmittedExportTargets } from './getSelectedExportTargets';

export const mapAudienceToCreateMutation = (
  user_id: string,
  values: AudienceForm,
  filteredAudienceCriteria: AudienceForm['normalized_definition']
): CreateAudienceMutationVariables['object'] => {
  return {
    account_id: values.account_id,
    user_id,
    name: values.name,
    description: values.description,
    export_type: values.export_type ?? exportType.OA_MATCH,
    export_targets: getSubmittedExportTargets(values),
    direct_audience_provider: values.direct_audience_provider ?? DEFAULT_PROVIDER_ID,
    normalized_definition: filteredAudienceCriteria,
  };
};
